import { LatestUsedCredentials } from '../../api/shared'
import { UseFormReturn } from 'react-hook-form/dist/types'
import { JiraIntegrationForm } from '../jira-form-schema'
import { JiraFormFieldTypes } from '../jira-form-field-types'

export type ConnectionStatus = 'valid' | 'invalid' | 'testing' | 'untested'

export interface JiraPageState {
  organizationUuid: string
  bugtrackerId?: number
  errorCode: number | null
  errorMessages: string[]
  fieldErrors: Array<{ message: string }>
  credentials: LatestUsedCredentials | null
  connectionStatus: ConnectionStatus
  previousDraftCredentials: LatestUsedCredentials | null
  previousDraftCredentialsConnectionStatus: ConnectionStatus
  previousSavedCredentialsName: string | null
  hasCredentialsUpdate: boolean
  isEdit: boolean
  isManagingCredentials: boolean
  isFormValid: boolean
}

export const initialState: JiraPageState = {
  organizationUuid: '',
  bugtrackerId: undefined,
  errorCode: null,
  errorMessages: [],
  fieldErrors: [],
  credentials: null,
  previousDraftCredentials: null,
  previousDraftCredentialsConnectionStatus: 'untested',
  previousSavedCredentialsName: null,
  connectionStatus: 'untested',
  isEdit: false,
  isManagingCredentials: false,
  isFormValid: false,
  hasCredentialsUpdate: false
}

export enum Action {
  UPDATE_FORM_DATA = 'UPDATE_FORM_DATA',
  UPDATE_SELECT_DATA = 'UPDATE_SELECT_DATA',
  UPDATE_ERROR_STATE = 'UPDATE_ERROR_STATE',
  UPDATE_ANY_STATE = 'UPDATE_ANY_STATE'
}

interface UpdateErrorState {
  type: Action.UPDATE_ERROR_STATE
  payload: {
    errorCode: number | null
    errorMessages: string[]
  }
}

export const updateErrorState = (errorState: {
  errorCode: number | null
  errorMessages: string[]
}): UpdateErrorState => ({
  type: Action.UPDATE_ERROR_STATE,
  payload: errorState
})

interface UpdateAnyState {
  type: Action.UPDATE_ANY_STATE
  payload: Partial<JiraPageState>
}

export const updateAnyState = (
  state: Partial<JiraPageState>
): UpdateAnyState => ({
  type: Action.UPDATE_ANY_STATE,
  payload: state
})

export const hasManageCredentialsDraftChanges = (
  { getValues }: UseFormReturn<JiraIntegrationForm>,
  { previousDraftCredentials }: Partial<JiraPageState>
) => {
  return (
    getValues(JiraFormFieldTypes.CREDENTIALS_HOST) !==
      previousDraftCredentials?.host ||
    getValues(JiraFormFieldTypes.CREDENTIALS_NAME) !==
      previousDraftCredentials?.name ||
    getValues(JiraFormFieldTypes.CREDENTIALS_PASSWORD) !==
      previousDraftCredentials?.password ||
    getValues(JiraFormFieldTypes.CREDENTIALS_USERNAME) !==
      previousDraftCredentials?.username
  )
}

export type ActionType = UpdateErrorState | UpdateAnyState

export const jiraIntegrationReducer = (
  state: JiraPageState,
  action: ActionType
) => {
  switch (action.type) {
    case Action.UPDATE_ERROR_STATE:
      return {
        ...state,
        errorCode: action.payload.errorCode,
        errorMessages: [...action.payload.errorMessages]
      }
    case Action.UPDATE_ANY_STATE:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
